/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";
import vsLoading from 'vuesax'
import store from './store/store'
import { AclRule } from 'vue-acl'

Vue.use(Router)
Vue.use(vsLoading)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    redirect: '/Inicio',
                    meta: {
                        rule: new AclRule('editor').generate()
                    }
                },
                {
                    path: '/Inicio',
                    name: 'dashboardAnalytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: new AclRule('editor').generate()
                    }
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboardAnalytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: new AclRule('editor').generate()
                    }
                },
                {
                    path: '/Admin',
                    name: 'dashboardECommerce',
                    component: () => import('./views/Conciliacao.vue'),
                    meta: {
                        rule: new AclRule('admin').generate()
                    }
                },
                {
                    path: '/Finance',
                    name: 'dashboardECommerce',
                    component: () => import('./views/Conciliacao.vue'),
                    meta: {
                        rule: new AclRule('admin').generate()
                    }
                },
                {
                    path: '/cadastro/produto',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/CadastroProduto.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
							              { title: 'Produto', active: true },
                        ],
                        pageTitle: 'Cadastrar Produto',
                        rule: new AclRule('admin').generate()
                    },
                },
                {
                    path: '/cadastro/seguradora',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/Seguradora.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
                            { title: 'Seguradora', active: true },
                        ],
                        pageTitle: 'Cadastro de Seguradora',
                        rule: 'admin'
                    },
                },
                {
                    path: '/cadastro/provedor',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/Provedor.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
                            { title: 'Provedor', active: true },
                        ],
                        pageTitle: 'Cadastro do Provedor',
                        rule: 'admin'
                    },
                },
                {
                    path: '/cadastro/franquia',
                    name: 'ecommerce-item-detail-view',
                    component: () => import('./views/forms/cadastro-franquia/FormWizard.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
                            { title: 'Franquia', active: true },
                        ],
                        pageTitle: 'Cadastro de Franquias',
                        rule: 'admin'
                    },
                },
                {
                    path: '/cadastro/franquia/lista',
                    name: 'ecommerce-item-detail-view',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/CadastroFranquia.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
                            { title: 'Franquia', active: true },
                        ],
                        pageTitle: 'Cadastro de Franquias',
                        rule: 'admin'
                    },
                },
                {
                    path: '/cadastro/usuario',
                    name: 'ecommerce-item-detail-view',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/CadastroUsuario.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadastro'},
                            { title: 'Usuário', active: true },
                        ],
                        pageTitle: 'Cadastro de Usuários',
                        rule: 'admin'
                    },
                },
                {
                    path: '/operacao/realizar',
                    name: 'eCommerceCheckout',
                    component: () => import('./views/apps/operacao/ECommerceCheckout.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Operação', url:'/operacao/lista'},
                            { title: 'Realizar', active: true },
                        ],
                        pageTitle: 'Realizar Operação',
                        rule: 'editor'
                    }
                },
                {
                    path: '/operacao/realizar/lote',
                    name: 'solicitarinvestimento',
                    component: () => import('@/views/pages/InvestimentoSolicitar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Operação' },
                            { title: 'Lote', active: true },
                        ],
                        pageTitle: 'Realizar Operação em Lote',
                        rule: 'editor'
                    },
                },
                {
                    path: '/cancelamento/realizar/lote',
                    name: 'solicitarinvestimento',
                    component: () => import('@/views/pages/CancelamentoSolicitar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Cancelamento' },
                            { title: 'Lote', active: true },
                        ],
                        pageTitle: 'Realizar Cancelamento em Lote',
                        rule: 'editor'
                    },
                },
				{
                    path: '/pagamentos/fatura',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/PagamentosFatura.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pagamentos'},
                            { title: 'Fatura', active: true },
                        ],
                        pageTitle: 'Pagar Fatura',
                        rule: 'editor'
                    },
                },
				{
                    path: '/movimento/financeiro',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/MovimentoFinanceiro.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Financeiro'},
                            { title: 'Movimentação', active: true },
                        ],
                        pageTitle: 'Movimentação Financeira',
                        rule: 'admin'
                    },
                },
                {
                            path: '/movimento/financeiro/extrato',
                            name: 'dataListListView',
                            component: () => import('@/views/ui-elements/data-list/list-view/MovimentoFinanceiro.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Home', url: '/' },
                                    { title: 'Financeiro'},
                                    { title: 'Extrato', active: true },
                                ],
                                pageTitle: 'Movimentação Extrato',
                                rule: 'admin'
                            },
                        },
                {
                    path: '/pagamentos/recarga',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/card/ReceberPagamentos.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pagamentos'},
                            { title: 'Recarga', active: true },
                        ],
                        pageTitle: 'Recarga Celular',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pagamentos/boleto',
                    name: 'dataListListView',
                    component: () => import('@/views/components/vuesax/dialogs/PagamentoBoleto.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pagamentos'},
                            { title: 'Boleto', active: true },
                        ],
                        pageTitle: 'Pagar Boletos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pagamentos/boleto/consumo',
                    name: 'dataListListView',
                    component: () => import('@/views/components/vuesax/dialogs/PagamentoBoletoConsumo.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pagamentos'},
                            { title: 'Boleto Consumo', active: true },
                        ],
                        pageTitle: 'Pagar Boletos Consumo',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/transacoes',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasTransacoes.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios'},
                            { title: 'Transações', active: true },
                        ],
                        pageTitle: 'Relatório de Transações',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/assinaturas',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasAssinaturas.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios'},
                            { title: 'Assinaturas', active: true },
                        ],
                        pageTitle: 'Relatório de Assinaturas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/assinaturas/falha',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasAssinaturasFalha.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios'},
                            { title: 'Assinaturas', active: true },
                        ],
                        pageTitle: 'Relatório de Assinaturas Falha',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/transacoes/lote',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasTransacoesLote.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios'},
                            { title: 'Transações', active: true },
                        ],
                        pageTitle: 'Relatório de Transações em Lote',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/transacoes/operador',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasTransacoesOperador.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Relatórios'},
                            { title: 'Transações', active: true },
                        ],
                        pageTitle: 'Relatório de Transações por Operador',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ted/contas/outra',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasContasTEDOutra.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transferência'},
							{ title: 'TED'},
                            { title: 'Outra Titularidade', active: true },
                        ],
                        pageTitle: 'Transferencia TED',
                        rule: 'editor'
                    },
                },
                {
                    path: '/doc/contas/pessoal',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasContasDOC.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transferência'},
							{ title: 'DOC'},
                            { title: 'Conta Pessoal', active: true },
                        ],
                        pageTitle: 'Transferencia DOC',
                        rule: 'editor'
                    },
                },
                {
                    path: '/doc/contas/outra',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/MinhasContasDOCOutra.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Transferência'},
							{ title: 'DOC'},
                            { title: 'Outra Titularidade', active: true },
                        ],
                        pageTitle: 'Transferencia DOC',
                        rule: 'editor'
                    },
                },
                {
                    path: '/deposito/boleto',
                    name: 'email',
                    component: () => import('./views/apps/saldo_boleto/Email.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Deposito'},
                            { title: 'Boleto', active: true },
                        ],
                        pageTitle: 'Deposito via Boleto',
                        rule: 'editor'
                    }
                },
                {
                    path: '/deposito/tev',
                    name: 'email',
                    component: () => import('./views/apps/saldo_tev/Email.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Deposito'},
                            { title: 'Transferência', active: true },
                        ],
                        pageTitle: 'Deposito via Transferência',
                        rule: 'editor'
                    }
                },
                {
                    path: '/deposito/bitcoin',
                    name: 'email',
                    component: () => import('./views/apps/saldo_bitcoin/Email.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Deposito'},
                            { title: 'Bitcoin', active: true },
                        ],
                        pageTitle: 'Deposito via Bitcoin',
                        rule: 'editor'
                    }
                },
                {
                    path: '/deposito/criptomoedas',
                    name: 'email',
                    component: () => import('./views/apps/saldo_altcoin/Email.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Deposito'},
                            { title: 'Criptomoedas', active: true },
                        ],
                        pageTitle: 'Deposito via Criptomoedas',
                        rule: 'editor'
                    }
                },
                {
                    path: '/extrato/transações',
                    name: 'dashboardAnalytics',
                    component: () => import('./views/Extrato.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extrato'},
                            { title: 'Transações', active: true },
                        ],
                        pageTitle: 'Minhas Transações',
                        rule: 'editor'
                    }
                },
                {
                    path: '/extrato/relatório',
                    name: 'dashboardAnalytics',
                    component: () => import('./views/forms/ExtratoRelatorio.vue'),
                    meta: {
						breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extrato'},
                            { title: 'Relatório', active: true },
                        ],
                        pageTitle: 'Gerar Relatório',
                        rule: 'editor'
                    }
                },
                {
                    path: '/uzecard/lista',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/EzoCard.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cartões'},
							{ title: 'UzeCard', active: true },
                        ],
                        pageTitle: 'Meus Cartões',
                        rule: 'editor'
                    },
                },
                {
                    path: '/apps/network',
                    name: 'dataListListView',
                    component: () => import('@/views/pages/Profile.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Apps'},
							{ title: 'UzeSocial', active: true },
                        ],
                        pageTitle: 'UzeSocial',
                        rule: 'editor'
                    },
                },
                {
                    path: '/apps/perfil',
                    name: 'dataListListView',
                    component: () => import('@/views/components/vuesax/edit_profile/Collapse.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Apps'},
							{ title: 'Minha Conta', active: true },
                        ],
                        pageTitle: 'Minha Conta',
                        rule: 'editor'
                    },
                },
        // =============================================================================
        // Application Routes
        // =============================================================================
                {
                    path: '/apps/todo',
                    name: 'todo',
                    component: () => import('./views/apps/todo/Todo.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/chat',
                    name: 'chat',
                    component: () => import('./views/apps/chat/Chat.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/email',
                    name: 'email',
                    component: () => import('./views/apps/email/Email.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/relatorio/calendario',
                    name: 'calendar',
                    component: () => import('./views/apps/Calendar.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/p2p/investimento/localizar',
                    name: 'eCommerceShop',
                    component: () => import('./views/apps/p2p/ECommerceShop.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'P2P'},
                            { title: 'Localizar', active: true },
                        ],
                        pageTitle: 'Localizar Investimento',
                        rule: 'editor'
                    }
                },
                {
                    path: '/p2p/investimentos/lista',
                    name: 'eCommerceWishList',
                    component: () => import('./views/ui-elements/data-list/list-view/MeusInvestimentos.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimentos', url:'/p2p/investimento/localizar'},
                            { title: 'Lista', active: true },
                        ],
                        pageTitle: 'Meus Investimentos',
                        rule: 'editor'
                    }
                },
                {
                    path: '/p2p/investimentos/solicitacao',
                    name: 'eCommerceWishList',
                    component: () => import('./views/ui-elements/data-list/list-view/MinhasPropostas.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimentos', url:'/p2p/investimento/localizar'},
                            { title: 'Solicitações', active: true },
                        ],
                        pageTitle: 'Minhas Solicitações',
                        rule: 'editor'
                    }
                },
                {
                    path: '/p2p/investimentos/investidores',
                    name: 'eCommerceWishList',
                    component: () => import('./views/ui-elements/data-list/list-view/MeusInvestidores.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimentos', url:'/p2p/investimento/localizar'},
                            { title: 'Investidores', active: true },
                        ],
                        pageTitle: 'Meus Investidores',
                        rule: 'editor'
                    }
                },
                {
                    path: '/p2p/investimentos/info/:item_id',
                    name: 'ecommerce-item-detail-view',
                    component: () => import('./views/apps/p2p/ECommerceItemDetailView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimento', url: '/p2p/investimento/localizar' },
                            { title: 'Informação', active: true },
                        ],
                        pageTitle: 'Informação Investimento',
                        rule: 'editor'
                    },
                },

                {
                    path: '/p2p/investimento/proposta/:item_id',
                    name: 'pageInvoice',
                    component: () => import('@/views/pages/Proposta.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimento' },
                            { title: 'Proposta', active: true },
                        ],
                        pageTitle: 'Proposta de Investimento',
                        rule: 'editor'
                    },
                },
                {
                    path: '/relatorio/assinatura/info/:item_id',
                    name: 'pageInvoice',
                    component: () => import('@/views/pages/Proposta.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Assinaturas' },
                            { title: 'Informação', active: true },
                        ],
                        pageTitle: 'Informações da Assinatura',
                        rule: 'editor'
                    },
                },
                {
                    path: '/p2p/investimento/finalizar',
                    name: 'eCommerceCheckout',
                    component: () => import('./views/apps/p2p/ECommerceCheckout.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimento', url:'/p2p/investimento/localizar'},
                            { title: 'Finalizar', active: true },
                        ],
                        pageTitle: 'Realizar Investimento',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/eCommerce/shop',
                    name: 'eCommerceShop',
                    component: () => import('./views/apps/eCommerce/ECommerceShop.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'eCommerce'},
                            { title: 'Shop', active: true },
                        ],
                        pageTitle: 'Shop',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/eCommerce/wish-list',
                    name: 'eCommerceWishList',
                    component: () => import('./views/apps/eCommerce/ECommerceWishList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'eCommerce', url:'/apps/eCommerce/shop'},
                            { title: 'Wish List', active: true },
                        ],
                        pageTitle: 'Wish List',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/eCommerce/checkout',
                    name: 'eCommerceCheckout',
                    component: () => import('./views/apps/eCommerce/ECommerceCheckout.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'eCommerce', url:'/apps/eCommerce/shop'},
                            { title: 'Checkout', active: true },
                        ],
                        pageTitle: 'Checkout',
                        rule: 'editor'
                    }
                },
        // =============================================================================
        // UI ELEMENTS
        // =============================================================================
                {
                    path: '/ui-elements/data-list/list-view',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/DataListListView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Data List'},
                            { title: 'List View', active: true },
                        ],
                        pageTitle: 'List View',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/data-list/thumb-view',
                    name: 'dataListThumbView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/DataListThumbView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Data List'},
                            { title: 'Thumb View', active: true },
                        ],
                        pageTitle: 'Thumb View',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/grid/vuesax',
                    name: 'gridVuesax',
                    component: () => import('@/views/ui-elements/grid/vuesax/GridVuesax.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Grid'},
                            { title: 'Vuesax', active: true },
                        ],
                        pageTitle: 'Grid',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/grid/tailwind',
                    name: 'gridTailwind',
                    component: () => import('@/views/ui-elements/grid/tailwind/GridTailwind.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Grid'},
                            { title: 'Tailwind', active: true },
                        ],
                        pageTitle: 'Tailwind Grid',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/colors',
                    name: 'colors',
                    component: () => import('./views/ui-elements/colors/Colors.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Colors', active: true },
                        ],
                        pageTitle: 'Colors',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/card/basic',
                    name: 'basicCards',
                    component: () => import('./views/ui-elements/card/CardBasic.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Basic Cards', active: true },
                        ],
                        pageTitle: 'Basic Cards',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/card/statistics',
                    name: 'statisticsCards',
                    component: () => import('./views/ui-elements/card/CardStatistics.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Statistics Cards', active: true },
                        ],
                        pageTitle: 'Statistics Card',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/card/analytics',
                    name: 'analyticsCards',
                    component: () => import('./views/ui-elements/card/CardAnalytics.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Analytics Card', active: true },
                        ],
                        pageTitle: 'Analytics Card',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/card/card-actions',
                    name: 'cardActions',
                    component: () => import('./views/ui-elements/card/cardActions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Card Actions', active: true },
                        ],
                        pageTitle: 'Card Actions',
                        rule: 'editor'
                    },
                },
                {
                    path: '/ui-elements/table',
                    name: 'table',
                    component: () => import('./views/ui-elements/table/Table.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Table', active: true },
                        ],
                        pageTitle: 'Table',
                        rule: 'editor'
                    },
                },

        // =============================================================================
        // COMPONENT ROUTES
        // =============================================================================
                {
                    path: '/components/alert',
                    name: 'componentAlert',
                    component: () => import('@/views/components/vuesax/alert/Alert.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Alert', active: true },
                        ],
                        pageTitle: 'Alert',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/avatar',
                    name: 'componentAvatar',
                    component: () => import('@/views/components/vuesax/avatar/Avatar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Avatar', active: true },
                        ],
                        pageTitle: 'Avatar',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/breadcrumb',
                    name: 'componentBreadcrumb',
                    component: () => import('@/views/components/vuesax/breadcrumb/Breadcrumb.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Breadcrumb', active: true },
                        ],
                        pageTitle: 'Breadcrumb',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/button',
                    name: 'componentButton',
                    component: () => import('@/views/components/vuesax/button/Button.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Button', active: true },
                        ],
                        pageTitle: 'Button',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/chip',
                    name: 'componentChip',
                    component: () => import('@/views/components/vuesax/chip/Chip.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Chip', active: true },
                        ],
                        pageTitle: 'Chip',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/collapse',
                    name: 'componentCollapse',
                    component: () => import('@/views/components/vuesax/collapse/Collapse.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Collapse', active: true },
                        ],
                        pageTitle: 'Collapse',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/dialogs',
                    name: 'componentDialog',
                    component: () => import('@/views/components/vuesax/dialogs/Dialogs.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Dialogs', active: true },
                        ],
                        pageTitle: 'Dialogs',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/divider',
                    name: 'componentDivider',
                    component: () => import('@/views/components/vuesax/divider/Divider.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Divider', active: true },
                        ],
                        pageTitle: 'Divider',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/dropdown',
                    name: 'componentDropDown',
                    component: () => import('@/views/components/vuesax/dropdown/Dropdown.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Dropdown', active: true },
                        ],
                        pageTitle: 'Dropdown',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/list',
                    name: 'componentList',
                    component: () => import('@/views/components/vuesax/list/List.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'List', active: true },
                        ],
                        pageTitle: 'List',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/loading',
                    name: 'componentLoading',
                    component: () => import('@/views/components/vuesax/loading/Loading.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Loading', active: true },
                        ],
                        pageTitle: 'Loading',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/navbar',
                    name: 'componentNavbar',
                    component: () => import('@/views/components/vuesax/navbar/Navbar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Navbar', active: true },
                        ],
                        pageTitle: 'Navbar',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/notifications',
                    name: 'componentNotifications',
                    component: () => import('@/views/components/vuesax/notifications/Notifications.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Notifications', active: true },
                        ],
                        pageTitle: 'Notifications',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/pagination',
                    name: 'componentPagination',
                    component: () => import('@/views/components/vuesax/pagination/Pagination.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Pagination', active: true },
                        ],
                        pageTitle: 'Pagination',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/popup',
                    name: 'componentPopup',
                    component: () => import('@/views/components/vuesax/popup/Popup.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Popup', active: true },
                        ],
                        pageTitle: 'Popup',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/progress',
                    name: 'componentProgress',
                    component: () => import('@/views/components/vuesax/progress/Progress.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Progress', active: true },
                        ],
                        pageTitle: 'Progress',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/sidebar',
                    name: 'componentSidebar',
                    component: () => import('@/views/components/vuesax/sidebar/Sidebar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Sidebar', active: true },
                        ],
                        pageTitle: 'Sidebar',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/slider',
                    name: 'componentSlider',
                    component: () => import('@/views/components/vuesax/slider/Slider.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Slider', active: true },
                        ],
                        pageTitle: 'Slider',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/tabs',
                    name: 'componentTabs',
                    component: () => import('@/views/components/vuesax/tabs/Tabs.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Tabs', active: true },
                        ],
                        pageTitle: 'Tabs',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/tooltip',
                    name: 'componentTooltip',
                    component: () => import('@/views/components/vuesax/tooltip/Tooltip.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Tooltip', active: true },
                        ],
                        pageTitle: 'Tooltip',
                        rule: 'editor'
                    },
                },
                {
                    path: '/components/upload',
                    name: 'componentUpload',
                    component: () => import('@/views/components/vuesax/upload/Upload.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Components' },
                            { title: 'Upload', active: true },
                        ],
                        pageTitle: 'Upload',
                        rule: 'editor'
                    },
                },


        // =============================================================================
        // FORMS
        // =============================================================================
            // =============================================================================
            // FORM ELEMENTS
            // =============================================================================
                {
                    path: '/forms/form-elements/select',
                    name: 'formElementSelect',
                    component: () => import('./views/forms/form-elements/select/Select.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Select', active: true },
                        ],
                        pageTitle: 'Select',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/switch',
                    name: 'formElementSwitch',
                    component: () => import('./views/forms/form-elements/switch/Switch.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Switch', active: true },
                        ],
                        pageTitle: 'Switch',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/checkbox',
                    name: 'formElementCheckbox',
                    component: () => import('./views/forms/form-elements/checkbox/Checkbox.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Checkbox', active: true },
                        ],
                        pageTitle: 'Checkbox',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/radio',
                    name: 'formElementRadio',
                    component: () => import('./views/forms/form-elements/radio/Radio.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Radio', active: true },
                        ],
                        pageTitle: 'Radio',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/input',
                    name: 'formElementInput',
                    component: () => import('./views/forms/form-elements/input/Input.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Input', active: true },
                        ],
                        pageTitle: 'Input',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/number-input',
                    name: 'formElementNumberInput',
                    component: () => import('./views/forms/form-elements/number-input/NumberInput.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Number Input', active: true },
                        ],
                        pageTitle: 'Number Input',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-elements/textarea',
                    name: 'formElementTextarea',
                    component: () => import('./views/forms/form-elements/textarea/Textarea.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Textarea', active: true },
                        ],
                        pageTitle: 'Textarea',
                        rule: 'editor'
                    },
                },
        // -------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/forms/form-layouts',
                    name: 'formsFormLayouts',
                    component: () => import('@/views/forms/FormLayouts.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Forms' },
                            { title: 'Form Layouts', active: true },
                        ],
                        pageTitle: 'Form Layouts',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-wizard',
                    name: 'extraComponentFormWizard',
                    component: () => import('@/views/forms/form-wizard/FormWizard.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Form Wizard', active: true },
                        ],
                        pageTitle: 'Form Wizard',
                        rule: 'editor'
                    },
                },
                {
                    path: '/forms/form-validation',
                    name: 'extraComponentFormValidation',
                    component: () => import('@/views/forms/form-validation/FormValidation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Form Validation', active: true },
                        ],
                        pageTitle: 'Form Validation',
                        rule: 'editor'
                    },
                },

        // =============================================================================
        // Pages Routes
        // =============================================================================
                {
                    path: '/pages/profile',
                    name: 'pageProfile',
                    component: () => import('@/views/pages/Profile.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'Profile', active: true },
                        ],
                        pageTitle: 'Profile',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/faq',
                    name: 'pageFAQ',
                    component: () => import('@/views/pages/Faq.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'FAQ', active: true },
                        ],
                        pageTitle: 'FAQ',
                        rule: 'editor'
                    },
                },
                {
                    path: '/p2p/investimento/solicitar',
                    name: 'solicitarinvestimento',
                    component: () => import('@/views/pages/InvestimentoSolicitar.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Investimento' },
                            { title: 'Solicitar', active: true },
                        ],
                        pageTitle: 'Solicitar Investimento',
                        rule: 'editor'
                    },
                },
                {
                    path: '/exchange/btc/painel',
                    name: 'cardActions',
                    component: () => import('./views/ui-elements/card/CompraVendaBTC.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Exchange' },
                            { title: 'BTC' },
                            { title: 'Compra e Venda', active: true },
                        ],
                        pageTitle: 'Compra e Venda (Básico)',
                        rule: 'editor'
                    },
                },
                {
                    path: '/exchange/btc/wallets',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/WalletsBTC.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Bitcoin'},
                            { title: 'Wallets', active: true },
                        ],
                        pageTitle: 'Minhas Carteiras',
                        rule: 'editor'
                    },
                },
                {
                    path: '/exchange/btc/transferir',
                    name: 'dataListListView',
                    component: () => import('@/views/ui-elements/data-list/list-view/PagamentosBitcoin.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Bitcoin'},
                            { title: 'Transferir', active: true },
                        ],
                        pageTitle: 'Enviar Bitcoin',
                        rule: 'editor'
                    },
                },
                {
                    path: '/documentos/upload/pj',
                    name: 'componentUpload',
                    component: () => import('@/views/components/vuesax/uploadpj/Upload.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Inicio', url: '/' },
                            { title: 'Documentos' },
                            { title: 'Upload', active: true },
                        ],
                        pageTitle: 'Envio de Documentos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/knowledge-base',
                    name: 'pageKnowledgeBase',
                    component: () => import('@/views/pages/KnowledgeBase.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', active: true },
                        ],
                        pageTitle: 'KnowledgeBase',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/knowledge-base/category',
                    name: 'pageKnowledgeBaseCategory',
                    component: () => import('@/views/pages/KnowledgeBaseCategory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
                            { title: 'Category', active: true },
                        ],
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/knowledge-base/category/question',
                    name: 'pageKnowledgeBaseCategoryQuestion',
                    component: () => import('@/views/pages/KnowledgeBaseCategoryQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
                            { title: 'Category', url: '/pages/knowledge-base/category' },
                            { title: 'Question', active: true },
                        ],
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/search',
                    name: 'pageSearch',
                    component: () => import('@/views/pages/Search.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'Search', active: true },
                        ],
                        pageTitle: 'Search',
                        rule: 'editor'
                    },
                },
                {
                    path: '/pages/invoice',
                    name: 'pageInvoice',
                    component: () => import('@/views/pages/Invoice.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'Invoice', active: true },
                        ],
                        pageTitle: 'Invoice',
                        rule: 'editor'
                    },
                },

        // =============================================================================
        // CHARTS & MAPS
        // =============================================================================
                {
                    path: '/charts-and-maps/charts/apex-charts',
                    name: 'extraComponentChartsApexCharts',
                    component: () => import('@/views/charts-and-maps/charts/apex-charts/ApexCharts.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Charts & Maps' },
                            { title: 'Apex Charts', active: true },
                        ],
                        pageTitle: 'Apex Charts',
                        rule: 'editor'
                    },
                },
                {
                    path: '/charts-and-maps/charts/chartjs',
                    name: 'extraComponentChartsChartjs',
                    component: () => import('@/views/charts-and-maps/charts/chartjs/Chartjs.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Charts & Maps' },
                            { title: 'chartjs', active: true },
                        ],
                        pageTitle: 'chartjs',
                        rule: 'editor'
                    },
                },
                {
                    path: '/charts-and-maps/charts/echarts',
                    name: 'extraComponentChartsEcharts',
                    component: () => import('@/views/charts-and-maps/charts/echarts/Echarts.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Charts & Maps' },
                            { title: 'echarts', active: true },
                        ],
                        pageTitle: 'echarts',
                        rule: 'editor'
                    },
                },
                {
                    path: '/charts-and-maps/maps/google-map',
                    name: 'extraComponentMapsGoogleMap',
                    component: () => import('@/views/charts-and-maps/maps/google-map/GoogleMap.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Charts & Maps' },
                            { title: 'Google Map', active: true },
                        ],
                        pageTitle: 'Google Map',
                        rule: 'editor'
                    },
                },



        // =============================================================================
        // EXTENSIONS
        // =============================================================================
                {
                    path: '/extensions/select',
                    name: 'extraComponentSelect',
                    component: () => import('@/views/components/extra-components/select/Select.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Select', active: true },
                        ],
                        pageTitle: 'Select',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/quill-editor',
                    name: 'extraComponentQuillEditor',
                    component: () => import('@/views/components/extra-components/quill-editor/QuillEditor.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Quill Editor', active: true },
                        ],
                        pageTitle: 'Quill Editor',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/drag-and-drop',
                    name: 'extraComponentDragAndDrop',
                    component: () => import('@/views/components/extra-components/drag-and-drop/DragAndDrop.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Drag & Drop', active: true },
                        ],
                        pageTitle: 'Drag & Drop',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/datepicker',
                    name: 'extraComponentDatepicker',
                    component: () => import('@/views/components/extra-components/datepicker/Datepicker.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Datepicker', active: true },
                        ],
                        pageTitle: 'Datepicker',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/access-control-editor',
                    name: 'extraComponentAccessControlEditor',
                    component: () => import('@/views/components/extra-components/access-control/AccessControlEditor.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'Access Control' },
                            { title: 'Editor View', active: true },
                        ],
                        pageTitle: 'Editor View',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/access-control-admin',
                    name: 'extraComponentAccessControlOnlyAdmin',
                    component: () => import('@/views/components/extra-components/access-control/AccessControlAdmin.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'Access Control' },
                            { title: 'Admin View', active: true },
                        ],
                        pageTitle: 'Admin View',
                        rule: 'admin'
                    },
                },
                {
                    path: '/extensions/i18n',
                    name: 'extraComponentI18n',
                    component: () => import('@/views/components/extra-components/I18n.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'I18n', active: true },
                        ],
                        pageTitle: 'I18n',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/carousel',
                    name: 'extraComponentCarousel',
                    component: () => import('@/views/components/extra-components/carousel/Carousel.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'Carousel', active: true },
                        ],
                        pageTitle: 'Carousel',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/clipboard',
                    name: 'extraComponentClipboard',
                    component: () => import('@/views/components/extra-components/clipboard/Clipboard.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'Clipboard', active: true },
                        ],
                        pageTitle: 'Clipboard',
                        rule: 'editor'
                    },
                },
                {
                    path: '/extensions/context-menu',
                    name: 'extraComponentContextMenu',
                    component: () => import('@/views/components/extra-components/context-menu/ContextMenu.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extensions' },
                            { title: 'Context Menu', active: true },
                        ],
                        pageTitle: 'Context Menu',
                        rule: 'editor'
                    },
                },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/callback',
                    name: 'authCallback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/login',
                    name: 'pageLogin',
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'pageRegister',
                    component: () => import('@/views/pages/Register.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'pageForgotPassword',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'pageResetPassword',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'pageLockScreen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/comingsoon',
                    name: 'pageComingSoon',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'pageError404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'pageError500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'pageNotAuthorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'pageMaintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {

		if(to.path != "/pages/login" && to.path != "/pages/forgot-password" && to.path != "/pages/error-404" && to.path != "/pages/error-500" && to.path != "/pages/register" && to.path != "/callback" && to.path != "/pages/comingsoon")
		{
      if(auth.isAuthenticated())
    	{

			fetch(store.state.API_URL+'validate/token', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.token == false)
				{
          console.log('Token false')
					router.push({ path: '/pages/login', query: { to: to.path } })
					localStorage.removeItem('userInfo');
					localStorage.removeItem('token');
					localStorage.removeItem('tokenExpiry');
					localStorage.removeItem('userRole');
				}
				else
				{
          //
          //acl.change(dados.rule);
          //console.log(to);
          /*const permissao = to.meta.rule.split(',');
          let valid = false;
          for (let i = 0; i < permissao.length; i++) {
            if(permissao[i] == dados.rule)
              valid = true;
          }
          if(!valid)
          {
            console.log(permissao);
            return next({
              path: '/Inicio',
              replace: true
            })
          }
          else*/
					  return next();
				}
			})
			.catch((error) => {
        console.log(error);
				router.push('/pages/login');
				localStorage.removeItem('userInfo');
				localStorage.removeItem('token');
				localStorage.removeItem('tokenExpiry');
				localStorage.removeItem('userRole');
			});
    }
    else{
      router.push({ path: '/pages/login', query: { to: to.path } })
    }

	}
  else
  {
    return next();
  }


});

export default router
